import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoIcon from "@mui/icons-material/Info";

const iconMap = {
  warning: <WarningAmberIcon color="warning" />,
  error: <ErrorOutlineIcon color="error" />,
  info: <InfoIcon color="info" />,
};

function CustomAlertDialog({
  open,
  onClose,
  title,
  message,
  iconType = "info",
  buttonText = "OK",
  onConfirm,
}) {
  const handleClose = () => {
    if (onConfirm) onConfirm();
    if (onClose) onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          fontFamily: "'Host Grotesk', sans-serif",
          color: "#2c4e80",
        }}
      >
        {iconMap[iconType] || iconMap.info}
        {title}
      </DialogTitle>
      <Box px={3} pb={2}>
        <Typography
          variant="body1"
          sx={{ fontFamily: "'Host Grotesk', sans-serif" }}
        >
          {message}
        </Typography>
      </Box>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClose}
          sx={{ fontFamily: "'Host Grotesk', sans-serif" }}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CustomAlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  iconType: PropTypes.oneOf(["info", "warning", "error"]),
  buttonText: PropTypes.string,
};

export default CustomAlertDialog;
